import React, {useRef, useState, useImperativeHandle, useEffect} from 'react'
import clsx from 'clsx'
import {CardEnum} from '@colonist/game-states'
import {UIGameCard} from '../UIGameCard'
import styles from './UIGameResourceCardsTooltipContent.module.scss'

export interface UIGameResourceCardsTooltipContentProps {
    cardsToBuild: CardEnum[]
    cardInventory: CardEnum[]
    ref?: React.Ref<UIGameResourceCardsTooltipContentHandle>
}

export interface UIGameResourceCardsTooltipContentHandle {
    triggerFlickerAnimation: () => void
}

export function UIGameResourceCardsTooltipContent({
    cardsToBuild,
    cardInventory,
    ref,
}: UIGameResourceCardsTooltipContentProps) {
    const [flickerAnimation, setFlickerAnimation] = useState(false)
    const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null)

    const triggerFlickerAnimation = () => {
        setFlickerAnimation(true)
        if(animationTimeoutRef.current) {
            clearTimeout(animationTimeoutRef.current)
        }
        animationTimeoutRef.current = setTimeout(() => {
            setFlickerAnimation(false)
            animationTimeoutRef.current = null
        }, 1000)
    }

    useEffect(() => () => {
        if(animationTimeoutRef.current) {
            clearTimeout(animationTimeoutRef.current)
        }
    }, [])

    useImperativeHandle(ref, () => ({
        triggerFlickerAnimation: triggerFlickerAnimation,
    }))

    const remainingInventory: Partial<Record<CardEnum, number>> = {}
    cardInventory.forEach((card) => {
        remainingInventory[card] = (remainingInventory[card] ?? 0) + 1
    })

    return (
        <div className={styles.container}>
            {cardsToBuild.map((card, index) => {
                let isMissingCard = false
                if(remainingInventory[card] != null && remainingInventory[card] > 0) {
                    remainingInventory[card] -= 1
                } else {
                    isMissingCard = true
                }
                return (
                    <UIGameCard
                        cardEnum={card}
                        size='sm'
                        className={clsx({
                            [styles.brightnessFlickerAnimation]: flickerAnimation && isMissingCard,
                        })}
                        isDisabled={isMissingCard}
                        key={index}
                    />
                )
            })}
        </div>
    )
}
